import BaseFilterModal from "./BaseFilterModal";

const EditFilterModal = ({
  open,
  onClose,
  onSave,
  filter,
  isLoading = false,
}) => {
  return (
    <BaseFilterModal
      open={open}
      onClose={onClose}
      onSave={onSave}
      title="Edit Filter"
      saveButtonText="Save Changes"
      appliedFilters={null}
      existingFilter={filter}
      isLoading={isLoading}
    />
  );
};

export default EditFilterModal;
